import React from 'react'

import { Link } from 'react-router-dom'

import { Container } from './styles'

const NotFound: React.FC = () => {
  return (
    <Container>
      <h1>Ops!</h1>
      <p>A página que você procura não foi encontrada :(</p>
      <Link to="/" className="action">
        Comece novamente
      </Link>
    </Container>
  )
}

export default NotFound
